
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.206 9.175l-4.081 8.275-9.131 1.331c-1.638.238-2.294 2.257-1.106 3.413l6.606 6.437-1.563 9.094c-.281 1.644 1.45 2.875 2.9 2.106L24 35.537l8.169 4.294c1.45.763 3.181-.462 2.9-2.106l-1.563-9.094 6.606-6.437c1.188-1.156.532-3.175-1.106-3.413l-9.131-1.331-4.081-8.275c-.732-1.475-2.85-1.494-3.588 0z","fill":"#535353"}})])
          )
        }
      }
    